module.exports = __webpack_public_path__ + "img/icon-statistics.a97bfc82.svg";